<template>
  <div>
    <div class="comment-title"><svg-icon icon-class="comment" class-name="blue--text"/>评论</div>
    <!-- 评论框 -->
    <div class="comment-input-wrapper">
      <div class="comment-input-cont">
        <v-avatar size="40">
          <img v-if="$store.getters.avatar" :src="avatar" alt=""/>
          <img v-else src="https://s2.loli.net/2023/05/26/qXTQ98fVKdte1a7.png" alt=""/>
        </v-avatar>
        <div class="comment-input-main ml-3">
          <div class="comment-input">
            <textarea class="comment-textarea" v-model="commentContent" placeholder="留下点什么吧..." auto-grow dense/>
          </div>
          <!-- 操作按钮 -->
          <div class="emoji-container">
            <span :class="chooseEmoji ? 'emoji-btn-active' : 'emoji-btn'" @click="chooseEmoji = !chooseEmoji">
              <svg-icon icon-class="emoji" />
            </span>
            <button @click="insertComment" class="upload-btn v-comment-btn" >提交</button>
          </div>
          <!-- 表情框 -->
          <emoji @addEmoji="addEmoji" :chooseEmoji="chooseEmoji" />
        </div>
      </div>
    </div>
    <!-- 评论详情 -->
    <div class="comment-list-wrapper" v-if="count > 0 && reFresh">
      <!-- 评论数量 -->
      <div class="count">{{ count }} 评论</div>
      <!-- 评论列表 -->
      <div class="comment-list-cont pt-5" v-for="(item, index) of commentList" :key="item.commentId">
        <!-- 头像 -->
        <v-avatar size="40" class="comment-avatar">
          <img :src="item.avatar" alt=""/>
        </v-avatar>
        <div class="comment-meta">
          <!-- 用户名 -->
          <div class="comment-user">
            <span v-if="!item.webSite">{{ item.nickname }}</span>
            <a v-else :href="item.webSite" target="_blank">{{ item.nickname }}</a>
            <span class="blogger-tag" v-if="item.userId == 1">博主</span>
          </div>
          <!-- 信息 -->
          <div class="comment-info">
            <!-- 楼层 -->
            <span class="mr-2">{{ count - index }}楼</span>
            <!-- 发表时间 -->
            <span class="mr-2">{{ item.createTime | datetime}}</span>
            <!-- 点赞 -->
            <svg-icon :class-name="isLike(item.commentId)" icon-class="like" @click="like(item)"/>
            <span v-show="item.likeCount > 0"> {{ item.likeCount }}</span>
            <!-- 回复 -->
            <span class="reply-btn" @click="replyComment(index, item)">回复</span>
          </div>
          <!-- 评论内容 -->
          <p v-html="item.commentContent" class="comment-content"></p>
          <!-- 回复人 -->
          <div class="reply-content" v-for="reply of item.replyDTOList" :key="reply.commentId">
            <!-- 头像 -->
            <v-avatar size="36" class="comment-avatar">
              <img :src="reply.avatar" alt=""/>
            </v-avatar>
            <div class="reply-meta">
              <!-- 用户名 -->
              <div class="comment-user">
                <span v-if="!reply.webSite">{{ reply.nickname }}</span>
                <a v-else :href="reply.webSite" target="_blank">{{ reply.nickname }}</a>
                <span class="blogger-tag" v-if="reply.userId == 1">博主</span>
              </div>
              <!-- 信息 -->
              <div class="comment-info">
                <!-- 发表时间 -->
                <span class="mr-2">{{ reply.createTime | datetime }}</span>
                <!-- 点赞 -->
                <svg-icon :class-name="isLike(reply.commentId)" icon-class="like" @click="like(reply)"/>
                <span v-show="reply.likeCount > 0"> {{ reply.likeCount }}</span>
                <!-- 回复 -->
                <span class="reply-btn" @click="replyComment(index, reply)">回复</span>
              </div>
              <!-- 回复内容 -->
              <p class="comment-content">
                <!-- 回复用户名 -->
                <template v-if="reply.replyId != item.userId">
                  <span v-if="!reply.replyWebSite" class="ml-1">@{{ reply.replyNickname }}</span>
                  <a v-else :href="reply.replyWebSite" target="_blank" class="comment-nickname ml-1">@{{ reply.replyNickname }}</a>，
                </template>
                <span v-html="reply.commentContent" />
              </p>
            </div>
          </div>
          <!-- 回复数量 -->
          <div class="reply-count mb-3" v-show="item.replyCount > 3" ref="check">
            共<b>{{ item.replyCount }}</b>条回复，<span class="reply-more" @click="checkReplies(index, item)">点击查看</span>
          </div>
          <!-- 回复分页 -->
          <div class="reply-page mb-3" ref="paging">
            <span class="pr-2">
              共{{ Math.ceil(item.replyCount / 5) }}页
            </span>
            <paging ref="page" :totalPage="Math.ceil(item.replyCount / 5)" :index="index" :commentId="item.commentId" @changeReplyCurrent="changeReplyCurrent"/>
          </div>
          <!-- 回复框 -->
          <Reply ref="reply" @reloadReply="reloadReply" />
        </div>
      </div>
      <!-- 加载按钮 -->
      <div class="load-wrapper">
        <v-btn outlined v-if="count > commentList.length" @click="listComments">加载更多...</v-btn>
      </div>
    </div>
    <!-- 没有评论提示 -->
    <div class="comment-empty" v-else >
      来发评论吧~
    </div>
  </div>
</template>

<script>
import Reply from "./Reply.vue";
import Paging from "./Paging.vue";
import Emoji from "./Emoji.vue";
import EmojiList from "../assets/js/emoji";
import {getCommentsList, getReplyList, likeComment, saveComment} from "@/api/comments";
import {getToken} from "@/utils/auth";
export default {
  components: {Reply, Emoji, Paging},
  props: {
    commentList: {
      type: Array
    },
    count: {
      type: Number
    }
  },
  data: function() {
    return {
      reFresh: true,
      commentContent: "",
      chooseEmoji: false,
      current: 1
    };
  },
  methods: {
    replyComment(index, item) {
      this.$refs.reply.forEach(item => {
        item.showReply = false;
      });
      //传值给回复框
      this.$refs.reply[index].commentContent = "";
      this.$refs.reply[index].nickname = item.nickname;
      this.$refs.reply[index].replyId = item.userId;
      this.$refs.reply[index].parentId = this.commentList[index].commentId;
      this.$refs.reply[index].chooseEmoji = false;
      this.$refs.reply[index].index = index;
      this.$refs.reply[index].showReply = true;
    },
    addEmoji(key) {
      this.commentContent += key;
    },
    checkReplies(index, item) {
      let params = { current: 1 };
      getReplyList(item.commentId, params).then(res => {
        this.$refs.check[index].style.display = "none";
        item.replyDTOList = res.data;
        //超过1页才显示分页
        if (Math.ceil(item.replyCount / 5) > 1) {
          this.$refs.paging[index].style.display = "flex";
        }
      });
    },
    changeReplyCurrent(current, index, commentId) {
      let params = { current: current };
      //查看下一页回复
      getReplyList(commentId, params).then(res => {
        this.commentList[index].replyDTOList = res.data;
      });
    },
    listComments() {
      //查看下一页评论
      this.current++;
      const path = this.$route.path;
      const arr = path.split("/");
      let params = { current: this.current, articleId: arr[2] };
      getCommentsList(params).then(res => {
        this.commentList.push(...res.rows);
      });
    },
    insertComment() {
      //判断登录
      if (!getToken()) {
        this.$store.dispatch('app/setLoginFlag',true);
        return false;
      }
      //判空
      if (this.commentContent.trim() == "") {
        this.$toast({ type: "error", message: "评论不能为空" });
        return false;
      }
      //解析表情
      var reg = /\[.+?\]/g;
      this.commentContent = this.commentContent.replace(reg, function(str) {
        return (
          '<img src="' + EmojiList[str] + '" width="22" height="20" class="comment-content-emoji"/>'
        );
      });
      //发送请求
      const path = this.$route.path;
      const arr = path.split("/");
      var comment = {
        articleId: arr[2],
        commentContent: this.commentContent
      };
      this.commentContent = "";
      saveComment(comment).then(res => {
        if (res.flag) {
          //查询最新评论
          this.$emit("reloadComment");
          this.$toast({ type: "success", message: res.msg });
        } else {
          this.$toast({ type: "error", message: res.msg });
        }
      });
    },
    like(comment) {
      //判断登录
      if (!getToken()) {
        this.$store.dispatch('app/setLoginFlag',true);
        return false;
      }
      //发送请求
      let idVo = { id: comment.commentId };
      likeComment(idVo).then(res => {
        if (res.flag) {
          //判断是否点赞
          if (this.$store.getters.commentLikeSet.indexOf(comment.commentId) != -1) {
            this.$set(comment, "likeCount", comment.likeCount - 1);
          } else {
            this.$set(comment, "likeCount", comment.likeCount + 1);
          }
          this.$store.dispatch("CommentLike", comment.commentId);
        }
      });
    },
    reloadReply(index) {
      let commentId = this.commentList[index].commentId;
      let params = { current: this.$refs.page[index].current };
      getReplyList(commentId, params).then(res => {
        this.commentList[index].replyCount++;
        //回复大于5条展示分页
        if (this.commentList[index].replyCount > 5) {
          this.$refs.paging[index].style.display = "flex";
        }
        this.$refs.check[index].style.display = "none";
        this.$refs.reply[index].showReply = false;
        this.commentList[index].replyDTOList = res.data;
      });
    }
  },
  computed: {
    isLike() {
      return function(commentId) {
        var commentLikeSet = this.$store.getters.commentLikeSet;
        return commentLikeSet.indexOf(commentId) != -1 ? "like-active" : "like";
      };
    },
    avatar(){
      return this.$store.getters.avatar;
    }
  },
  watch: {
    commentList() {
      this.reFresh = false;
      this.$nextTick(() => {
        this.reFresh = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 1.25rem !important;
}
.blogger-tag {
  background: #ffa51e;
  font-size: 12px;
  display: inline-block;
  border-radius: 2px;
  color: #fff;
  padding: 0 5px;
  margin-left: 6px;
}
.comment-title {
  display: flex;
  align-items: center;
  gap:4px;
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 40px;
  margin-bottom: 10px;
}
.comment-input-wrapper {
  border: 1px solid #90939950;
  border-radius: 4px;
  padding: 10px;
  margin: 0 0 10px;
  .comment-input-cont{
    display:flex;
    .comment-input-main{
      width: 100%;
    }
  }
}
.comment-list-wrapper{
  .count {
    padding: 5px;
    line-height: 1.75;
    font-size: 1.25rem;
    font-weight: bold;
  }
  .comment-list-cont{
    display: flex;
  }
}

.comment-meta {
  margin-left: 0.8rem;
  width: 100%;
  border-bottom: 1px dashed #f5f5f5;
  .comment-info {
    line-height: 1.75;
    font-size: 0.75rem;
    color: #b3b3b3;
    display: flex;
    align-items: center;
  }
  .reply-content{
    display:flex
  }
  .reply-count {
    font-size:0.75rem;
    color:#6d757a;
    .reply-more {
      color:#00a1d6;
      cursor:pointer;
    }
  }
  .reply-page{
    font-size:0.75rem;
    color:#222;
    display:none;
  }
}
.reply-meta {
  margin-left: 0.8rem;
  width: 100%;

}
.comment-user {
  font-size: 14px;
  line-height: 1.75;
}
.comment-user a {
  color: #1abc9c !important;
  font-weight: 500;
  transition: 0.3s all;
}
.comment-nickname {
  text-decoration: none;
  color: #1abc9c !important;
  font-weight: 500;
}

.reply-btn {
  cursor: pointer;
  color: #ef2f11;
  margin-left: auto;
}
.comment-content {
  font-size: 0.875rem;
  line-height: 1.75;
  padding-top: 0.625rem;
  .comment-content-emoji{
    margin:0 1px;
  }
}
.comment-avatar {
  transition: all 0.5s;
}
.comment-avatar:hover {
  transform: rotate(360deg);
}
.like {
  cursor: pointer;
  font-size: 0.875rem;
}
.like:hover {
  color: #eb5055;
}
.like-active {
  cursor: pointer;
  font-size: 0.875rem;
  color: #eb5055;
}
.load-wrapper {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.load-wrapper button {
  background-color: #49b1f5;
  color: #fff;
}
.comment-empty{
  padding: 1.25rem;
  text-align:center
}
</style>
